( ( $ ) => {
	"use strict";

	const $nav = $( '.section-gamers .gamers-ages__nav' );
	const $slider = $( '.section-gamers .gamers-ages__slides' );

	function initSlider( $sliderEl ) {
		$sliderEl.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			mobileFirst: true,
			arrows: false,
			dots: false,
			fade: true,
		} ).on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
			console.log( currentSlide );
			setActive( $slider, $nav, nextSlide );
		} );
	}

	function initNav( $navEl, $sliderEl ) {
		if ( window.innerWidth <= 1200 && ( !$navEl.hasClass( 'slick-initialized' ) ) ) {
			$navEl.slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				mobileFirst: true,
				arrows: false,
				dots: false,
				asNavFor: $sliderEl,
				// centerMode: true,
				focusOnSelect: true,
				responsive: [
					{
						breakpoint: 1199,
						settings: 'unslick'
					},
				]
			} );
		}
	}

	function setActive( $sliderEl, $navEl, slideIndex ) {
		const $btn = $navEl.find( '.gamers-ages__nav-item' ).eq( slideIndex );
		const $slide = $sliderEl.find( '.gamers-ages__slide' ).eq( slideIndex );
		$navEl.find( '.gamers-ages__nav-item' ).not( $btn ).removeClass( 'active' );
		$btn.addClass( 'active' );
		if ( $navEl.hasClass( 'slick-initialized' ) ) {
			$navEl.slick( 'slickGoTo', slideIndex );
		}
		$sliderEl.find( '.gamers-ages__slide' ).not( $slide ).removeClass( 'active' );
		$slide.addClass( 'active' );
	}

	$nav.on( 'click', 'a', function ( event ) {
		event.preventDefault();
		const $btn = $( this );
		const slideIndex = $btn.index();
		$slider.slick( 'slickGoTo', slideIndex );
		// setActive( $slider, $nav, slideIndex );
	} );

	$( window ).on( 'load resize', function () {
		initNav( $nav, $slider );
	} );

	initSlider( $slider );

} )( jQuery );